var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.post.PostTagLists && _vm.post.PostTagLists[0].PostTagUserID)?_c('div',{staticClass:"d-block"},[_c('div',{staticClass:"d-block"},[_c('K2Icon',{attrs:{"name":"file_download","link":true},on:{"onclick":()=>_vm.generatePostPDF(_vm.post)}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }